import { createClient } from 'contentful';

export default createClient({
	space: 'qvs343g4070c',
	accessToken: '4K2TyopSxzMJ8zM3ORs75-oFaXUYyYyiZ4HJFkoxZHM'
});